module.exports = __webpack_public_path__ + "img/MELA_Endothelial.48320aed.png";